import { render, staticRenderFns } from "./SponsorCapture.vue?vue&type=template&id=dc0b3be0&scoped=true"
import script from "./SponsorCapture.vue?vue&type=script&lang=js"
export * from "./SponsorCapture.vue?vue&type=script&lang=js"
import style0 from "./SponsorCapture.vue?vue&type=style&index=0&id=dc0b3be0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0b3be0",
  null
  
)

export default component.exports